import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { ToastProvider } from "@cx/ui";
// Ordem do CSS: Bootstrap + regras do app, depois o Coup (sobrescreve o Bootstrap), depois os tokens (FE5, FE24).
import "./styles/index.scss";
import "./styles/coup";
import "./styles/tokens.css";
import { SessionProvider } from "./session";
import { LoginPage } from "./pages/LoginPage";
import { router } from "./routes";

// PDV (T3.1): tela cheia em /pdv, fora do layout e da sessão do ERP (funciona sem conexão com a sessão guardada).
const PdvApp = lazy(() => import("./pdv/PdvApp").then((m) => ({ default: m.PdvApp })));
const isPdv = /^\/pdv(\/|$)/.test(window.location.pathname);

const qc = new QueryClient({
  defaultOptions: { queries: { staleTime: 15_000, refetchOnWindowFocus: false } },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <ToastProvider>
        {isPdv ? (
          <Suspense
            fallback={
              <div className="p-5 text-center" role="status">
                Carregando o PDV…
              </div>
            }
          >
            <PdvApp />
          </Suspense>
        ) : (
          <SessionProvider fallback={<LoginPage />}>
            <RouterProvider router={router} />
          </SessionProvider>
        )}
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
